//import OrganizationSettings from "./Organization.screen";
//import Profile from "./Profile.screen";

const Settings = {
    // OrganizationSettings,
    // Profile
}

export default Settings